import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_biomar_header = _resolveComponent("biomar-header")!
  const _component_biomar_header_mobile = _resolveComponent("biomar-header-mobile")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_biomar_footer = _resolveComponent("biomar-footer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (! _ctx.mobileView)
      ? (_openBlock(), _createBlock(_component_biomar_header, { key: 0 }))
      : _createCommentVNode("", true),
    (_ctx.mobileView)
      ? (_openBlock(), _createBlock(_component_biomar_header_mobile, { key: 1 }))
      : _createCommentVNode("", true),
    _createVNode(_component_router_view),
    _createVNode(_component_biomar_footer)
  ], 64))
}